import { type PlaceDetails } from "types/quote-types";
import { apiFetch } from ".";
import {
  type CheckoutWalletPaymentInfo,
  type CreditCardPaymentInfo,
  type PaymentService,
  type PaymentType,
  type PayPalPaymentInfo,
  type StripeWalletPaymentInfo,
} from "./payment";

export interface PolicyPaymentResponse {
  policyUrl: string;
  receiptUrl: string;
  userPolicy: {
    id?: number;
    uniqueUuid?: string;
  };
}
export interface PolicyAmendmentPaymentInfo {
  paymentService: PaymentService;
  purchasePaymentType: PaymentType;
}

export interface PolicyAmendmentPaymentResponse {
  additionalCharge: number;
  days: number;
  destinations: PlaceDetails[];
  paymentService: PaymentService;
  noOfTravelers: number;
  policyCodeHash: string;
  policyGroup: string;
  tripStartDate: string;
  tripEndsDate: string;
}

export async function getPolicyPaymentAmendmentInfo(
  hash: string,
): Promise<PolicyAmendmentPaymentResponse> {
  const response = await apiFetch(`policy/amendment/link/payment/info/${hash}`);
  return await response.json();
}

export async function sendPolicyAmendmentPayment(
  paymentInfo:
    | CheckoutWalletPaymentInfo<PolicyAmendmentPaymentInfo>
    | CreditCardPaymentInfo<PolicyAmendmentPaymentInfo>
    | PayPalPaymentInfo<PolicyAmendmentPaymentInfo>
    | StripeWalletPaymentInfo<PolicyAmendmentPaymentInfo>,
  paymentLinkHash: string,
): Promise<PolicyPaymentResponse> {
  const response = await apiFetch("policy/amendment/pay/payment/link", {
    body: JSON.stringify({ paymentLinkHash, ...paymentInfo }),
    method: "POST",
  });

  return await response.json();
}
